import { getClientType } from '../../../tools/session/clientSession';
import { fetchClientJSON } from '../../../tools/uploads/uploadsClient';

export const fetchEnvironmentData = () => fetchClientJSON(getClientType(), 'Environment_1h.json');
export const fetchEnvironmentDailyData = (date) => fetchClientJSON(getClientType(), `ambientali/${date}.json`);
export const fetchEnvironmentIndex = () => fetchClientJSON(getClientType(), 'ambientali/media_giornaliera.json');
export const fetchEnvironmentFileIndex = () => fetchEnvironmentIndex();
export const fetchNoiseData = () => fetchClientJSON(getClientType(), 'Noise_1min.json');
export const fetchDetectedSounds = () => fetchClientJSON(getClientType(), 'detected_sounds.json');
export const fetchNoiseDailyData = (date) => fetchClientJSON(getClientType(), `geojson/${date}.json`);
export const fetchNoiseIndex = () => fetchClientJSON(getClientType(), 'geojson/json_index.json');
export const fetchVibrationData = () => fetchClientJSON(getClientType(), 'Vibration_1min.json');
export const fetchIMUData = (filename) => fetchClientJSON(getClientType(), `imu/${filename}`);
export const fetchIMUIndex = () => fetchClientJSON(getClientType(), 'imu/index.json');
